import axios from 'axios';
import { GetGaUserCode, GetUserIdCookie } from "../commom/userCode";
import { getAuthToken } from "../commom/authToken";

const printAxios = axios.create({
  baseURL: "https://print-service-646460948106.us-central1.run.app",
});

printAxios.interceptors.request.use(
  (config) => {
    const token = getAuthToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

printAxios.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      config.data = {
        ...config.data,
        uniqueGaId: GetGaUserCode(),
        userIdCookie: GetUserIdCookie()
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/*
 * Interceptador de resposta para tratar sessão inválida.
 * 403: token expirado (fluxo antigo do identifyUser).
 * 401: rota protegida por requireAuthenticatedUser sem token válido.
 */
printAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;

    if (status === 401 || status === 403) {
        window.location.href = '/logout';
    }
    return Promise.reject(error);
  }
);

export default printAxios;
